import React, { useState } from 'react';
import classes from '../../../assets/Global.module.css';
import Button from '../../../assets/essentials/Button';
import Input from '../../../assets/essentials/Input';
import PostBody from '../../../api/internal/PostBody';
import Modal from '../../../helpers/modal/Modal';
import PutBody from '../../../api/internal/PutBody';
import CloseModal from '../../../helpers/modal/CloseModal';
import CloseSlab from '../../../helpers/slab/Close';
import Create from '../../../helpers/modal/CreateModal';

export default function Admin({
  data,
  vendorId,
  RefreshPage,
}: {
  data: VendorAdmin;
  vendorId: number;
  RefreshPage: Function;
}) {
  const { quickBooksVendorId } = data;
  const [selectedQuickBooksVendorId, setSelectedQuickBooksVendorId] =
    useState(quickBooksVendorId);
  const [isLoading, setIsLoading] = useState(false);


  const handleUpdateVendorAdmin = () => {
    setIsLoading(true);
    PutBody(`/Vendor/UpdateVendorAdmin`, {
      vendorId: vendorId,
      quickBooksVendorId: selectedQuickBooksVendorId,
    })
      .then(response => {
        if (response) {
          RefreshPage('Admin', ['Audit']);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const CreateQuickbooksIdButton = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    function PostVendorToQuickbooks() {
      setIsLoading(true);
      if (vendorId)
        PostBody('Accounting/PostVendorToQuickBooks', {
          vendorId: Number(vendorId),
        })
          .then(response => {
            if (response) {
              RefreshPage('Admin', ['Audit']);
            }
          })
          .finally(() => setIsLoading(false));
    }
    return (
      <div>
        {isLoading ? (
          <Button disabled>Pending...</Button>
        ) : (
          <Button onClick={() => PostVendorToQuickbooks()} type="button">
            Post To QuickBooks
          </Button>
        )}
      </div>
    );
  };

  const DeleteVendorModal = ({ isActive }) => {
    const handleDeleteVendor = () => {
      PutBody('/Vendor/UpdateVendorAdmin', {
        vendorId: vendorId,
        isActive: !isActive,
      }).then(response => {
        if (response) {
          CloseModal();
          CloseSlab();
        }
      });
    };
    return (
      <Modal>
        <div className={classes.flexColumnAlignCenter}>
          <h4>{isActive ? 'Delete Vendor' : 'Reactivate Vendor'}</h4>
          <p>
            Are you sure you want to {isActive ? 'delete' : 'reactivate'} this
            vendor?
          </p>
          <div className={classes.sideBySideButtons}>
            <Button
              onClick={handleDeleteVendor}
              variant={isActive ? 'bad' : 'good'}
            >
              {isActive ? 'Delete' : 'Reactivate'}
            </Button>
            <Button onClick={CloseModal}>Cancel</Button>
          </div>
        </div>
      </Modal>
    );
  };

  const handleClick = () => {
    Create(<DeleteVendorModal isActive={data.isActive} />);
  };

  return (
    <div>
      <section>
        <div className={`${classes.attribute}`}>
          <label htmlFor="quickBooksVendorId">QuickBooks Vendor ID</label>
          <Input
            value={selectedQuickBooksVendorId || ''}
            onChange={e => setSelectedQuickBooksVendorId(e.target.value)}
            id="quickBooksVendorId"
            name="quickBooksVendorId"
          />
        </div>
        <div>
          <Button
            onClick={handleUpdateVendorAdmin}
            disabled={isLoading}
            variant="good"
            type="button"
          >
            {isLoading ? 'Saving...' : 'Save Changes'}
          </Button>
        </div>
      </section>
      {!quickBooksVendorId && (
        <div className={classes.marginTop1Rem}>
          <CreateQuickbooksIdButton />
        </div>
      )}
      <br />
      <br />
      <div>
        <Button variant={data.isActive ? 'bad' : ''} onClick={handleClick}>
          {data.isActive ? 'Delete Vendor' : 'Reactivate Vendor'}
        </Button>
      </div>
    </div>
  );
}
